const CHATBOT = 'chatbot';
const ANONRUBOT = 'anonrubot';

const project = {
  CHATBOT,
  ANONRUBOT
};

export default project;
